"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeAllWordingTranslationsWithSpecialSuffix = exports.removeAllInsightToReportTranslations = exports.pickCorrectWording = exports.pickCorrectMetricWording = exports.pickCorrectInsightWording = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2022 GoodData Corporation
var memoize_one_1 = tslib_1.__importDefault(require("memoize-one"));
var getNewKey = function (key, stringToRemove) { return key.replace(stringToRemove, ""); };
var pickCorrectInsightWordingInner = function (translations, isEnabledInsightToReport) {
    var modifiedTranslations = {};
    Object.keys(translations).forEach(function (key) {
        if (key.includes("|report") || key.includes("|insight")) {
            var newKey = getNewKey(key, isEnabledInsightToReport ? "|report" : "|insight");
            modifiedTranslations[newKey] = translations[key];
        }
    });
    return tslib_1.__assign(tslib_1.__assign({}, translations), modifiedTranslations);
};
/**
 * Even this simple translations-reference-based cache is very effective as most of the time the 'translations'
 * objects come from some static constant.
 */
var memoizedPickCorrectInsightWordingInner = memoize_one_1.default(pickCorrectInsightWordingInner);
/**
 * @beta
 */
exports.pickCorrectInsightWording = function (translations, settings) {
    var isEnabledInsightToReport = !!(settings === null || settings === void 0 ? void 0 : settings.enableInsightToReport);
    return memoizedPickCorrectInsightWordingInner(translations, isEnabledInsightToReport);
};
var pickCorrectMetricWordingInner = function (translations, isEnabledRenamingMeasureToMetric) {
    var modifiedTranslations = {};
    Object.keys(translations).forEach(function (key) {
        if (key.includes("._metric") || key.includes("._measure")) {
            var newKey = getNewKey(key, isEnabledRenamingMeasureToMetric ? "._metric" : "._measure");
            modifiedTranslations[newKey] = translations[key];
        }
    });
    return tslib_1.__assign(tslib_1.__assign({}, translations), modifiedTranslations);
};
/**
 * Even this simple translations-reference-based cache is very effective as most of the time the 'translations'
 * objects come from some static constant.
 */
var memoizedPickCorrectMetricWordingInner = memoize_one_1.default(pickCorrectMetricWordingInner);
/**
 * The function to pick correct wording 'measure' or 'metric'
 * @beta
 */
exports.pickCorrectMetricWording = function (translations, settings) {
    var isEnabledRenamingMeasureToMetric = !!(settings === null || settings === void 0 ? void 0 : settings.enableRenamingMeasureToMetric);
    return memoizedPickCorrectMetricWordingInner(translations, isEnabledRenamingMeasureToMetric);
};
/**
 * @beta
 */
exports.pickCorrectWording = function (translations, settings) {
    return exports.pickCorrectMetricWording(exports.pickCorrectInsightWording(translations, settings), settings);
};
/**
 * @beta
 */
exports.removeAllInsightToReportTranslations = function (translations) {
    Object.keys(translations).forEach(function (key) {
        if (key.includes("|report") || key.includes("|insight")) {
            delete translations[key];
        }
    });
    return tslib_1.__assign({}, translations);
};
/**
 * The function to remove all translation keys that contain special suffixes "|report", "|insight", "._measure" or "._metric"
 * @beta
 */
exports.removeAllWordingTranslationsWithSpecialSuffix = function (translations) {
    Object.keys(translations).forEach(function (key) {
        if (key.includes("|report") ||
            key.includes("|insight") ||
            key.includes("._measure") ||
            key.includes("._metric")) {
            delete translations[key];
        }
    });
    return tslib_1.__assign({}, translations);
};
//# sourceMappingURL=utils.js.map